var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "flex",
        staticStyle: { "margin-top": "13px", "margin-bottom": "20px" },
      },
      [
        _c("div", [
          _c(
            "div",
            {
              class:
                _vm.achType === "论文"
                  ? "selectAchievementTitle"
                  : "achievementTitle",
              staticStyle: { margin: "0 auto", width: "100px" },
              on: {
                click: function ($event) {
                  return _vm.changeAchType("论文")
                },
              },
            },
            [_vm._v(" 论文(" + _vm._s(_vm.paperData.paperElements) + ") ")]
          ),
          _vm.achType === "论文"
            ? _c("div", {
                staticStyle: { "border-bottom": "2px solid #1241C9" },
              })
            : _vm._e(),
        ]),
        _vm.patentData.patentElements
          ? _c("div", [
              _c(
                "div",
                {
                  class:
                    _vm.achType === "专利"
                      ? "selectAchievementTitle"
                      : "achievementTitle",
                  staticStyle: { margin: "0 auto", width: "100px" },
                  on: {
                    click: function ($event) {
                      return _vm.changeAchType("专利")
                    },
                  },
                },
                [
                  _vm._v(
                    " 专利(" + _vm._s(_vm.patentData.patentElements) + ") "
                  ),
                ]
              ),
              _vm.achType === "专利"
                ? _c("div", {
                    staticStyle: { "border-bottom": "2px solid #1241C9" },
                  })
                : _vm._e(),
            ])
          : _vm._e(),
        _vm.projectData.projectElements
          ? _c("div", [
              _c(
                "div",
                {
                  class:
                    _vm.achType === "项目"
                      ? "selectAchievementTitle"
                      : "achievementTitle",
                  staticStyle: { margin: "0 auto", width: "100px" },
                  on: {
                    click: function ($event) {
                      return _vm.changeAchType("项目")
                    },
                  },
                },
                [
                  _vm._v(
                    " 项目(" + _vm._s(_vm.projectData.projectElements) + ") "
                  ),
                ]
              ),
              _vm.achType === "项目"
                ? _c("div", {
                    staticStyle: { "border-bottom": "2px solid #1241C9" },
                  })
                : _vm._e(),
            ])
          : _vm._e(),
      ]
    ),
    _vm.achType === "论文"
      ? _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.paperLoading,
                expression: "paperLoading",
              },
            ],
            staticStyle: { "min-height": "400px" },
          },
          [
            _c(
              "div",
              {
                staticClass: "text-left",
                staticStyle: {
                  "margin-bottom": "20px",
                  color: "rgba(218, 10, 10, 0.7)",
                },
              },
              [
                _vm._v(
                  " 注：该作者共发表论文" +
                    _vm._s(_vm.paperData.paperElements) +
                    "篇；其中第一作者论文数为" +
                    _vm._s(_vm.paperData.paperAuthor || 0) +
                    "篇； "
                ),
                _vm.paperData.paperLeadAndVenueVO
                  ? _c("span", [
                      _vm.paperData.paperLeadAndVenueVO?.nature &&
                      _vm.paperData.paperLeadAndVenueVO?.nature !== 0
                        ? _c("span", [
                            _vm._v(
                              "发表Nature" +
                                _vm._s(
                                  _vm.paperData.paperLeadAndVenueVO?.nature
                                ) +
                                "篇；"
                            ),
                          ])
                        : _vm._e(),
                      _vm.paperData.paperLeadAndVenueVO?.science &&
                      _vm.paperData.paperLeadAndVenueVO?.science !== 0
                        ? _c("span", [
                            _vm._v(
                              "发表Science" +
                                _vm._s(
                                  _vm.paperData.paperLeadAndVenueVO?.science
                                ) +
                                "篇；"
                            ),
                          ])
                        : _vm._e(),
                      _vm.paperData.paperLeadAndVenueVO?.cell &&
                      _vm.paperData.paperLeadAndVenueVO?.cell !== 0
                        ? _c("span", [
                            _vm._v(
                              "发表Cell" +
                                _vm._s(
                                  _vm.paperData.paperLeadAndVenueVO?.cell
                                ) +
                                "篇；"
                            ),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ]
            ),
            _c(
              "div",
              { staticClass: "selectType flex items-center flex-wrap" },
              [
                _vm.paperYearOptions && _vm.paperYearOptions.length
                  ? _c(
                      "el-select",
                      {
                        attrs: {
                          "popper-class": "advanced-select",
                          placeholder: "年份",
                          size: "mini",
                          multiple: "",
                          clearable: "",
                          "collapse-tags": "",
                        },
                        on: { change: _vm.paperYearChange },
                        model: {
                          value: _vm.paperYear,
                          callback: function ($$v) {
                            _vm.paperYear = $$v
                          },
                          expression: "paperYear",
                        },
                      },
                      _vm._l(_vm.paperYearOptions, function (item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: {
                            label: `${item.year} (${item.yearCount})`,
                            value: item.year,
                          },
                        })
                      }),
                      1
                    )
                  : _vm._e(),
                _vm.paperFieldsOptions && _vm.paperFieldsOptions.length
                  ? _c(
                      "el-select",
                      {
                        staticStyle: { "margin-left": "20px" },
                        attrs: {
                          "popper-class": "advanced-select",
                          placeholder: "主题筛选",
                          size: "mini",
                          multiple: "",
                          clearable: "",
                          "collapse-tags": "",
                        },
                        on: { change: _vm.paperFieldChange },
                        model: {
                          value: _vm.paperField,
                          callback: function ($$v) {
                            _vm.paperField = $$v
                          },
                          expression: "paperField",
                        },
                      },
                      _vm._l(_vm.paperFieldsOptions, function (item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: {
                            label: `${item.name} (${item.count})`,
                            value: item.id,
                          },
                        })
                      }),
                      1
                    )
                  : _vm._e(),
                _vm.paperJourOptions && _vm.paperJourOptions.length
                  ? _c(
                      "el-select",
                      {
                        staticStyle: { "margin-left": "20px" },
                        attrs: {
                          "popper-class": "advanced-select",
                          placeholder: "核心期刊",
                          size: "mini",
                          multiple: "",
                          clearable: "",
                          "collapse-tags": "",
                        },
                        on: { change: _vm.paperJourChange },
                        model: {
                          value: _vm.paperJour,
                          callback: function ($$v) {
                            _vm.paperJour = $$v
                          },
                          expression: "paperJour",
                        },
                      },
                      _vm._l(_vm.paperJourOptions, function (item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: {
                            label: `${item.paperType} (${item.paperTypeCount})`,
                            value: item.paperType,
                          },
                        })
                      }),
                      1
                    )
                  : _vm._e(),
                _vm.paperJcrOptions && _vm.paperJcrOptions.length
                  ? _c(
                      "el-select",
                      {
                        staticStyle: { "margin-left": "20px" },
                        attrs: {
                          "popper-class": "advanced-select",
                          placeholder: "JCR分区",
                          size: "mini",
                          multiple: "",
                          clearable: "",
                          "collapse-tags": "",
                        },
                        on: { change: _vm.paperJcrChange },
                        model: {
                          value: _vm.paperJcr,
                          callback: function ($$v) {
                            _vm.paperJcr = $$v
                          },
                          expression: "paperJcr",
                        },
                      },
                      _vm._l(_vm.paperJcrOptions, function (item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: {
                            label: `${item.JcrArea || item.jcrArea} (${
                              item.jcrAreaCount || item.JcrAreaCount
                            })`,
                            value: item.JcrArea || item.jcrArea,
                          },
                        })
                      }),
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-checkbox",
                  {
                    staticStyle: { "margin-left": "20px" },
                    on: { change: _vm.paperSortChange },
                    model: {
                      value: _vm.paperSort,
                      callback: function ($$v) {
                        _vm.paperSort = $$v
                      },
                      expression: "paperSort",
                    },
                  },
                  [_vm._v("引用量排序")]
                ),
                _c(
                  "el-checkbox",
                  {
                    on: { change: _vm.lookFirstAuthorPaper },
                    model: {
                      value: _vm.firstAuthor,
                      callback: function ($$v) {
                        _vm.firstAuthor = $$v
                      },
                      expression: "firstAuthor",
                    },
                  },
                  [_vm._v("只看一作论文")]
                ),
              ],
              1
            ),
            _vm._l(_vm.paperData.paperList, function (item, index) {
              return _c(
                "div",
                { key: index, staticClass: "text-left item-bottom" },
                [
                  _c("achievement-item", {
                    attrs: { "ach-type": "论文", "ach-data": item },
                  }),
                ],
                1
              )
            }),
            _vm.paperData.paperList && _vm.paperData.paperList.length
              ? _c(
                  "div",
                  { staticClass: "page-container" },
                  [
                    _c("el-pagination", {
                      attrs: {
                        background: "",
                        "current-page": _vm.achParams.pageNo + 1,
                        "page-size": _vm.achParams.pageSize,
                        "page-sizes": [10, 20, 50, 100],
                        layout: "sizes,prev, pager, next",
                        total: _vm.paperData.paperElements,
                      },
                      on: {
                        "current-change": _vm.handleCurrentChange,
                        "size-change": _vm.handleSizeChange,
                      },
                    }),
                  ],
                  1
                )
              : _c("el-empty"),
          ],
          2
        )
      : _vm._e(),
    _vm.achType === "专利"
      ? _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.patentLoading,
                expression: "patentLoading",
              },
            ],
            staticStyle: { "min-height": "400px" },
          },
          [
            _c(
              "div",
              { staticClass: "selectType" },
              [
                _c(
                  "el-select",
                  {
                    attrs: {
                      "popper-class": "advanced-select",
                      placeholder: "申请年份",
                      size: "mini",
                      multiple: "",
                      clearable: "",
                      "collapse-tags": "",
                    },
                    on: { change: _vm.yearChange },
                    model: {
                      value: _vm.patentYear,
                      callback: function ($$v) {
                        _vm.patentYear = $$v
                      },
                      expression: "patentYear",
                    },
                  },
                  _vm._l(_vm.patentYearOptions, function (item, index) {
                    return _c("el-option", {
                      key: index,
                      attrs: {
                        label: `${item.year} (${item.yearCount})`,
                        value: item.year,
                      },
                    })
                  }),
                  1
                ),
                _c(
                  "el-select",
                  {
                    staticStyle: { "margin-left": "20px" },
                    attrs: {
                      "popper-class": "advanced-select",
                      placeholder: "专利类型",
                      size: "mini",
                      multiple: "",
                      clearable: "",
                      "collapse-tags": "",
                    },
                    on: { change: _vm.patentTypeChange },
                    model: {
                      value: _vm.patentType,
                      callback: function ($$v) {
                        _vm.patentType = $$v
                      },
                      expression: "patentType",
                    },
                  },
                  _vm._l(_vm.patentTypeOptions, function (item, index) {
                    return _c("el-option", {
                      key: index,
                      attrs: {
                        label: `${item.patentType} (${item.patentTypeCount})`,
                        value: item.patentType,
                      },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _vm._l(_vm.patentData.patentList, function (item, index) {
              return _c(
                "div",
                { key: index, staticClass: "text-left item-bottom" },
                [
                  _c("achievement-item", {
                    attrs: { "ach-type": "专利", "ach-data": item },
                  }),
                ],
                1
              )
            }),
            _vm.patentData.patentList && _vm.patentData.patentList.length
              ? _c(
                  "div",
                  { staticClass: "page-container" },
                  [
                    _c("el-pagination", {
                      attrs: {
                        background: "",
                        "current-page": _vm.achParams.pageNo + 1,
                        "page-size": _vm.achParams.pageSize,
                        "page-sizes": [10, 20, 50, 100],
                        layout: "sizes,prev, pager, next",
                        total: _vm.patentData.patentElements,
                      },
                      on: {
                        "current-change": _vm.handleCurrentChange,
                        "size-change": _vm.handleSizeChange,
                      },
                    }),
                  ],
                  1
                )
              : _c("el-empty"),
          ],
          2
        )
      : _vm._e(),
    _vm.achType === "项目"
      ? _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.projectLoading,
                expression: "projectLoading",
              },
            ],
            staticStyle: { "min-height": "400px", "margin-top": "-10px" },
          },
          [
            _vm.projectData.projectList && _vm.projectData.projectList.length
              ? _c(
                  "div",
                  _vm._l(_vm.projectData.projectList, function (project) {
                    return _c(
                      "div",
                      { key: project.id, staticClass: "project-item" },
                      [
                        _c("achievement-item", {
                          attrs: { "ach-type": "项目", "ach-data": project },
                        }),
                      ],
                      1
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm.projectData.projectList && _vm.projectData.projectList.length
              ? _c(
                  "div",
                  { staticClass: "page-container" },
                  [
                    _c("el-pagination", {
                      attrs: {
                        background: "",
                        "current-page": _vm.achParams.pageNo + 1,
                        "page-size": _vm.achParams.pageSize,
                        "page-sizes": [10, 20, 50, 100],
                        layout: "sizes,prev, pager, next",
                        total: _vm.projectData.projectElements,
                      },
                      on: {
                        "current-change": _vm.handleCurrentChange,
                        "size-change": _vm.handleSizeChange,
                      },
                    }),
                  ],
                  1
                )
              : _c("el-empty"),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }